<template>
  <v-data-table class="sms-credits-list"
                :headers="headers"
                :items="creditsList"
                :loading="loading"
                :hide-actions="true"
                :no-data-text="$t('message.creditManagement.message.noCreditsRegistered')"
                :no-results-text="$t('message.generics.message.noData')">

    <template slot="items"
              slot-scope="props">
      <SmsCreditListItem :creditItem="props.item"
                         :item="item"
                         @deleted="emitReload" />
    </template>
  </v-data-table>
</template>

<script>
import SmsCreditListItem from "@components/sms/SmsCreditListItem";

export default {
  components: {
    SmsCreditListItem,
  },
  data() {
    return {
      page: 0,
      headers: [
        { text: this.$t('message.creditManagement.message.createdAt'), value: "creationDate", sortable: false, width: 50 },
        { text: this.$t('message.generics.message.amount'), value: "amount", sortable: false },
        { text: this.$t('message.creditManagement.message.expiration'), value: "expirationDate", sortable: false },
        { text: this.$t('message.creditManagement.message.used'), value: "", sortable: false },
        { text: this.$t('message.creditManagement.message.type'), value: "", sortable: false },
        { text: this.$t('message.creditManagement.message.cancellationDate'), value: "cancellationDate", sortable: false },
        { text: "", value: "", sortable: false },
      ],
      showPlanAddForm: false,
    };
  },
  props: {
    creditsList: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    value: {
      type: Number,
    },
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitAddPlan() {
      this.$emit("addPlan");

      this.showPlanAddForm = true;
    },
    setSelectedId(value) {
      if (value.selected) {
        return this.$emit("input", value.id);
      }

      this.$emit("input", undefined);
    },
    emitReload() {
      this.$emit("reload");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
